/* ─────────────────────────────────────────────────────────────
   ComputedField — a READ-ONLY display of a value the server computed (ENT-565 FR-67).

   The client never computes this value and never lets a person change it: there is no input, no
   `onChange` call and no formatting beyond turning the server's string or number into text. A new
   value from the server shows on the next render; nothing a person types anywhere affects it.

   Config (field.props):
   - testId (string, optional) — `data-testid` of the displayed value.
   ───────────────────────────────────────────────────────────── */

import type { FieldDisplayProps, FieldRendererProps } from '../../config/types';
import { Text } from '@/components/ui/Text';

import { computedText } from './computedText';

export function ComputedControl({ id, value, testId }: { id?: string; value: unknown; testId?: string }) {
  return (
    <Text variant="body-md" as="div" mono id={id} data-testid={testId}>
      {computedText(value)}
    </Text>
  );
}

export function ComputedFieldRenderer({ field, value }: FieldRendererProps) {
  const testId = typeof field.props?.testId === 'string' ? field.props.testId : undefined;
  return <ComputedControl id={field.id} value={value} testId={testId} />;
}

export function ComputedDisplay({ value }: FieldDisplayProps) {
  return (
    <Text variant="body-md" mono>
      {computedText(value)}
    </Text>
  );
}
